module.exports = __webpack_public_path__ + "img/20.645f5d5.jpg";